import { createFileRoute, Outlet } from '@tanstack/react-router';
import { userQueries } from '@/features/auth/queries';
import { PageLoader } from '@/common/components/page-loader/PageLoader.tsx';
import { ModalProvider } from '@/common/components/modal-provider/ModalProvider';
import { AppLayout } from '@/features/navigation/components/app-layout/AppLayout';
import { SupplyPointProvider } from '@/features/supply-points/context/SupplyPointProvider.tsx';
import { getAccessToken } from '@/features/auth/tokenStore';
import { refreshAccessToken } from '@/features/auth/interceptors/authInterceptor';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    if (!getAccessToken()) {
      await refreshAccessToken();
    }
    await context.queryClient.ensureQueryData(userQueries.getCurrentUser());
  },
  pendingComponent: PageLoader,
  component: () => (
    <ModalProvider>
      <SupplyPointProvider>
        <AppLayout>
          <Outlet />
        </AppLayout>
      </SupplyPointProvider>
    </ModalProvider>
  ),
});
